import { MY_LEARNING_QUERY_PARAM, QUERY_PARAM_VALUES } from 'bundles/unified-home-common/constants/MyLearningConstants';

import _t from 'i18n!nls/consumer-home';

export const getEnterpriseMyLearningLinks = (programSlug?: string, enableSkillsDashboard?: boolean) => {
  const { IN_PROGRESS, COMPLETED, SAVED, SKILLS_DASHBOARD } = QUERY_PARAM_VALUES;
  const baseUrl = `/programs/${programSlug}/my-learning?${MY_LEARNING_QUERY_PARAM}=`;

  const links = [
    { label: _t('In Progress'), url: `${baseUrl}${IN_PROGRESS}`, trackingName: 'in_progress' },
    { label: _t('Saved'), url: `${baseUrl}${SAVED}`, trackingName: 'saved' },
    { label: _t('Completed'), url: `${baseUrl}${COMPLETED}`, trackingName: 'completed' },
    ...(enableSkillsDashboard
      ? [{ label: _t('Skills'), url: `${baseUrl}${SKILLS_DASHBOARD}`, trackingName: 'skills' }]
      : []),
  ];

  return links;
};
